import React from 'react'
import { Avatar, Col, Row } from 'antd'
import { Text } from '../../../shared.style'
import { numberWithCommas } from '../../../utils/number'
import moment from 'moment'
import { getMapUrl } from '../../../utils'

const FactoryDetail = (props) => {
  const { factory } = props

  function getProductSample(text) {
    if (text === 'รูปภาพสินค้า') {
      return 'กรุณาส่งรูปภาพสินค้าให้พิจารณาก่อนขาย'
    } else if (text === 'ตัวอย่างสินค้า') {
      return 'กรุณาส่งตัวอย่างสินค้าก่อนขาย'
    } else {
      return ''
    }
  }

  function getIncludeVat(isVat, price) {
    const vat = Number(price) + Number(price * 0.07)
    if (isVat) {
      return `(รวม VAT ${numberWithCommas(Number(vat), 2)} บาท)`
    } else {
      return '(ไม่รวม VAT)'
    }
  }

  return (
    <div>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Row justify="end" align="middle" gutter={8}>
            <Col>
              <Text>{factory.hero.name}</Text>
            </Col>
            <Col>
              <Avatar src={factory.hero.image} size={48} />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={6}>
              <Row justify="end">
                <Text size={20}>ประกาศตามหา :</Text>
              </Row>
            </Col>
            <Col span={18}>
              <Row gutter={8}>
                <Col>
                  <Text size={20}>{factory.material.name}</Text>
                </Col>
                <Col>
                  <Avatar src={factory.material.productImage} size={32} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={6}>
              <Row justify="end">
                <Text size={18}>รูปแบบ :</Text>
              </Row>
            </Col>
            <Col span={18}>
              <Text size={18}>{factory.productManagement}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={6}>
              <Row justify="end">
                <Text size={18}>รถขนส่ง :</Text>
              </Row>
            </Col>
            <Col span={18}>
              <Text size={18}>{factory.transports}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={6}>
              <Row justify="end">
                <Text size={18}>ปริมาณรับขั้นต่ำ :</Text>
              </Row>
            </Col>
            <Col span={18}>
              <Text size={18}>{`${factory.amountMinimum} ต่อเที่ยว`}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={6}>
              <Row justify="end">
                <Text size={18}>หลักฐานผู้ขาย :</Text>
              </Row>
            </Col>
            <Col span={18}>
              <Text size={18}>{factory.presaleDocument}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={6}>
              <Row justify="end">
                <Text size={18}>การจ่ายเงิน :</Text>
              </Row>
            </Col>
            <Col span={18}>
              <Text size={18}>{factory.payments}</Text>
            </Col>
          </Row>
        </Col>
        {factory.remark && (
          <Col span={24}>
            <Row gutter={8}>
              <Col span={6}>
                <Row justify="end">
                  <Text size={18}>เงื่อนไขอื่นๆ :</Text>
                </Row>
              </Col>
              <Col span={18}>
                <Text size={18}>{factory.remark}</Text>
              </Col>
            </Row>
          </Col>
        )}
        <Col span={24}>
          <Row justify="center">
            <Text>{getProductSample(factory.productSample)}</Text>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="center">
            <Text size={24} bold>{`ราคา ${numberWithCommas(
              factory.price,
              2
            )} บาท ต่อ ${factory.material.unit}`}</Text>
          </Row>
          <Row justify="center">
            <Text size={24} bold>
              {getIncludeVat(factory.includeVat, factory.price)}
            </Text>
          </Row>
          <Row justify="center">
            <Text size={18}>
              ภายในวันที่ {moment(factory.expirationDate).format('DD MMM YYYY')}
            </Text>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={12}>
              <Row justify="end">
                <Text size={18}>ติดต่อ LINE ID :</Text>
              </Row>
            </Col>
            <Col span={12}>
              <Text size={18}>{factory.hero.lineId || '-'}</Text>
            </Col>
          </Row>
          <Row gutter={8} justify="center">
            <Col span={12}>
              <Row justify="end">
                <Text size={18}>โทรศัพท์ :</Text>
              </Row>
            </Col>
            <Col span={12}>
              <Text size={18}>{factory.hero.tel}</Text>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col span={12}>
              <Row justify="end">
                <Text size={18}>ที่ตั้งโรงงาน :</Text>
              </Row>
            </Col>
            <Col span={12}>
              <a
                href={getMapUrl(factory.hero.location)}
                target="_blank"
                rel="noreferrer">
                <Text size={18} color="#6ebf4b">
                  ดูแผนที่
                </Text>
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default FactoryDetail



// WEBPACK FOOTER //
// ./src/pages/FactoryAnnouncement/FactoryDetail/index.js